function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        filter: url(#filter);\n      }\n\n      .cls-3 {\n        filter: url(#filter-2);\n      }\n\n      .cls-4 {\n        filter: url(#filter-3);\n      }\n\n      .cls-5 {\n        filter: url(#filter-4);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
  id: "filter",
  x: 134.25,
  y: 134.25,
  width: 115.75,
  height: 231.5,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  result: "flood",
  floodColor: "#646464"
}), /*#__PURE__*/React.createElement("feComposite", {
  result: "composite",
  operator: "in",
  in2: "SourceGraphic"
}), /*#__PURE__*/React.createElement("feBlend", {
  result: "blend",
  in2: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter-2",
  x: 134.25,
  y: 134.25,
  width: 115.75,
  height: 145.75,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  result: "flood",
  floodColor: "#e7e7e7"
}), /*#__PURE__*/React.createElement("feComposite", {
  result: "composite",
  operator: "in",
  in2: "SourceGraphic"
}), /*#__PURE__*/React.createElement("feBlend", {
  result: "blend",
  in2: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter-3",
  x: 250,
  y: 134.25,
  width: 115.75,
  height: 231.5,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  result: "flood",
  floodColor: "#b9b9b9"
}), /*#__PURE__*/React.createElement("feComposite", {
  result: "composite",
  operator: "in",
  in2: "SourceGraphic"
}), /*#__PURE__*/React.createElement("feBlend", {
  result: "blend",
  in2: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter-4",
  x: 250,
  y: 134.25,
  width: 115.75,
  height: 145.75,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  result: "flood",
  floodColor: "#fff"
}), /*#__PURE__*/React.createElement("feComposite", {
  result: "composite",
  operator: "in",
  in2: "SourceGraphic"
}), /*#__PURE__*/React.createElement("feBlend", {
  result: "blend",
  in2: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M385.026,160.7l89.3,89.3H410.746l-89.3-89.3h63.583Zm0,0,89.3,89.3H410.746l-89.3-89.3h63.583Zm0,0,89.3,89.3H410.746l-89.3-89.3h63.583Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Shape_3_copy",
  "data-name": "Shape 3 copy",
  className: "cls-1",
  d: "M410.746,250l-89.3,89.3h63.583l89.3-89.3H410.746Zm0,0-89.3,89.3h63.583l89.3-89.3H410.746Zm0,0-89.3,89.3h63.583l89.3-89.3H410.746Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Shape_3_copy_2",
  "data-name": "Shape 3 copy 2",
  className: "cls-1",
  d: "M114.974,160.7L25.67,250H89.254l89.3-89.3H114.974Zm0,0L25.67,250H89.254l89.3-89.3H114.974Zm0,0L25.67,250H89.254l89.3-89.3H114.974Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Shape_3_copy_2-2",
  "data-name": "Shape 3 copy 2",
  className: "cls-1",
  d: "M89.254,250l89.3,89.3H114.974L25.67,250H89.254Zm0,0,89.3,89.3H114.974L25.67,250H89.254Zm0,0,89.3,89.3H114.974L25.67,250H89.254Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M250,134.263V365.737L134.263,250Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Shape_7_copy",
  "data-name": "Shape 7 copy",
  className: "cls-3",
  d: "M250,134.263V280.006L134.263,250Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Shape_7_copy_2",
  "data-name": "Shape 7 copy 2",
  className: "cls-4",
  d: "M250,134.263V365.737L365.737,250Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Shape_7_copy_2-2",
  "data-name": "Shape 7 copy 2",
  className: "cls-5",
  d: "M250,134.263V280.006L365.737,250Z"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b9646424.svg";
export { ForwardRef as ReactComponent };